'use client';

import { useClientTranslation } from '@bts-web/utils-lokalise';
import { useDrawerContext } from '../../../../../common/components/ModalDrawerContext/ModalDrawerContext';
import { useIsBelowScreenWidth } from '../../../../../layouts/utils/useIsBelowScreenWidth';
import { StopOrderInfoDrawer } from '../../../../../orders/components/StopOrderInfoDrawer/StopOrderInfoDrawer';
import { ButtonBase } from '../../../../../common/components';

const LearnMoreOrderDrawerButton = () => {
  const { openDrawer } = useDrawerContext();

  const { t } = useClientTranslation();

  const isMobile = useIsBelowScreenWidth(1024);

  const onClick = () => {
    openDrawer(StopOrderInfoDrawer, {
      title: t('stop_order_title_@tenant'),
      position: isMobile ? 'bottom' : 'right',
    });
  };

  return (
    <ButtonBase size="extra_small" visual="tertiary" onClick={onClick}>
      {t('learn_more')}
    </ButtonBase>
  );
};

export { LearnMoreOrderDrawerButton };
